// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"254":"cb7c5a14","280":"448c540d","293":"86bcb6f5","301":"6f932ef8","445":"21c47432","530":"0854940c","728":"81fca047","733":"ab6a0ef8","759":"9548cfb3","892":"187c88aa","921":"c56cbb7c","935":"e8f1891b","971":"8eda34ca"}[chunkId] + ".chunk.js";
};